import React from 'react';
const TermsOfService = () => {
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1361">
      <div className="max-w-3xl mx-auto" data-id="element-1362">
        <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1363">
          Terms of Service
        </h1>
        <div className="text-sm text-gray-500 mb-8" data-id="element-1364">
          Last updated: June 1, 2023
        </div>
        <div className="prose prose-lg max-w-none" data-id="element-1365">
          <p data-id="element-1366">
            Please read these Terms of Service ("Terms") carefully before using
            the LaraDevs website and services.
          </p>
          <h2 data-id="element-1367">1. Acceptance of Terms</h2>
          <p data-id="element-1368">
            By accessing or using our Services, you agree to be bound by these
            Terms. If you do not agree to these Terms, you may not access or use
            the Services.
          </p>
          <h2 data-id="element-1369">2. Description of Services</h2>
          <p data-id="element-1370">
            LaraDevs provides a platform connecting developers, freelancers, and
            teams with potential employers and clients. Our Services include
            developer profiles, job listings, team pages, blog content, and
            other related features.
          </p>
          <h2 data-id="element-1371">3. User Accounts</h2>
          <p data-id="element-1372">
            To access certain features of our Services, you must register for an
            account. You agree to provide accurate, current, and complete
            information during the registration process and to update such
            information to keep it accurate, current, and complete.
          </p>
          <p data-id="element-1373">
            You are responsible for safeguarding your account and password. You
            agree not to disclose your password to any third party and to take
            sole responsibility for any activities or actions under your
            account, whether or not you have authorized such activities or
            actions.
          </p>
          <h2 data-id="element-1374">4. User Content</h2>
          <p data-id="element-1375">
            Our Services may allow you to post, link, store, share and otherwise
            make available certain information, text, graphics, videos, or other
            material ("Content"). You are responsible for the Content that you
            post on or through the Services, including its legality,
            reliability, and appropriateness.
          </p>
          <p data-id="element-1376">
            By posting Content on or through the Services, you represent and
            warrant that:
          </p>
          <ul data-id="element-1377">
            <li data-id="element-1378">
              The Content is yours (you own it) or you have the right to use it
              and grant us the rights and license as provided in these Terms
            </li>
            <li data-id="element-1379">
              The posting of your Content on or through the Services does not
              violate the privacy rights, publicity rights, copyrights, contract
              rights or any other rights of any person
            </li>
          </ul>
          <h2 data-id="element-1380">5. Fees and Payment</h2>
          <p data-id="element-1381">
            Certain aspects of the Services may be provided for a fee. You agree
            to pay all fees in accordance with the pricing and payment terms
            presented to you for such Services.
          </p>
          <p data-id="element-1382">
            You will provide us with valid, up-to-date, and complete credit card
            or other payment information. You authorize us to charge such
            payment information for all Services listed in an order for the
            initial subscription term and any renewal subscription term.
          </p>
          <h2 data-id="element-1383">6. Termination</h2>
          <p data-id="element-1384">
            We may terminate or suspend your account and bar access to the
            Services immediately, without prior notice or liability, under our
            sole discretion, for any reason whatsoever and without limitation,
            including but not limited to a breach of the Terms.
          </p>
          <p data-id="element-1385">
            If you wish to terminate your account, you may simply discontinue
            using the Services, or notify us that you wish to delete your
            account.
          </p>
          <h2 data-id="element-1386">7. Limitation of Liability</h2>
          <p data-id="element-1387">
            In no event shall LaraDevs, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from:
          </p>
          <ul data-id="element-1388">
            <li data-id="element-1389">
              Your access to or use of or inability to access or use the
              Services
            </li>
            <li data-id="element-1390">Any conduct or content of any third party on the Services</li>
            <li data-id="element-1391">Any content obtained from the Services</li>
            <li data-id="element-1392">
              Unauthorized access, use or alteration of your transmissions or
              content
            </li>
          </ul>
          <h2 data-id="element-1393">8. Governing Law</h2>
          <p data-id="element-1394">
            These Terms shall be governed and construed in accordance with the
            laws of California, United States, without regard to its conflict of
            law provisions.
          </p>
          <h2 data-id="element-1395">9. Changes to Terms</h2>
          <p data-id="element-1396">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will provide
            at least 30 days' notice prior to any new terms taking effect. What
            constitutes a material change will be determined at our sole
            discretion.
          </p>
          <h2 data-id="element-1397">10. Contact Us</h2>
          <p data-id="element-1398">
            If you have any questions about these Terms, please contact us at:
          </p>
          <p data-id="element-1399">
            Email: legal@laradevs.com
            <br data-id="element-1400" />
            Address: 123 Developer Way, Suite 456, San Francisco, CA 94103
          </p>
        </div>
      </div>
    </div>;
};
export default TermsOfService;